module.exports = __webpack_public_path__ + "static/media/90088A.89fc5395.png";